import 'Utils/jTabs.js';
import 'Utils/mere.js';
import 'readmore-js';
import { searchbarFixedHeight } from 'Utils/ha-searcbar-functions';
import { updateUI } from 'SrcJS/script--updateUI';
import('Vendors/jquery.haScrollFix');

AppLoader.ready(function () {
    var mtop = 6; //search bar 80 + margin 6
    var mbottom = 0;
    var cookieInfo = $('#cookieInformerBooklet .content');
    if (cookieInfo.length > 0)
        mbottom = cookieInfo.outerHeight();

    $('.menu-floater').haScrollFix({
        marginTop: mtop,
        spaceHeight: $(window).height() - mtop - mbottom,
        //limit: function () { return $('.hotel-search-split').offset().top; }
        limit: function () {
            var holder = $('#tabs.hotelsite');
            if (holder.length > 0)
                return holder.offset().top + holder.outerHeight();
            else
                return $('.hotel-search-split').offset().top;
        },
        canUse: function () {
            var result = false;
            result = $(window).width() > 1262;
            var holder = $('#tabs.hotelsite [class^="row"]');
            if (holder.length > 0) {
                var h = holder.height();
                //var bc = $('article.site-content .breadcrumbs');
                //if (bc.length > 0)
                //    h = h - bc.outerHeight(true);
                //var dab = $('.destination-action-buttons');
                //if (dab.length > 0)
                //    h = h - dab.outerHeight(true);
                result &= h > $('.menu-floater').outerHeight();
            }
            return result;
        },
        fixedTopHeight: function () {
            return searchbarFixedHeight();
        },
        selectorHolder: $('#tabs.hotelsite [class^="row"]')
    });
});

AppLoader.ready(function () {

    let moreLink = $('#tabs #moreLink').html();
    let lessLink = $('#tabs #lessLink').html();
    let c = 0;

    $('.mootabs_panel .readmoreHeight').each(function () {
        let $this = $(this);
        let $parent = $this.closest('.mootabs_panel');
        let id = $this.attr('id');
        if (!id || id == '') {
            id = 'mootabs_panel__readmoreHeight-' + c;
            $this.attr('id', id);
            c++;
        }

        $parent.filter(':not(.active)').show();
        let readmore_speed = 100;
        $(this).readmore({
            //selector: '.mootabs_panel .readmoreHeight',
            selector: '#' + id,
            speed: readmore_speed,
            collapsedHeight: 230,
            heightMargin: 26,
            embedCSS: false,
            //moreLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up mere-button-end">@(txtReadMore)</a>',
            //lessLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up mere-button-end expanded">@(Html.Translate(TranslationKeys.HotelPage.ShowLess))</a>',
            moreLink: moreLink,
            lessLink: lessLink,
            afterToggle: function (trigger, element, expanded) {
                if (!expanded) { // The "Close" link was clicked
                    $('html, body').stop().animate({
                        scrollTop: element.offset().top - searchbarFixedHeight()
                    }, readmore_speed);
                }
                AppLoader.raf(function () {
                    updateUI();
                }, readmore_speed + 32);
            }
        }).removeClass('readmore-placeholder');
        $parent.filter(':not(.active)').hide();
    });

    // BoxWithSubMenu expand destination list
    $(document).on('click', '.destinations-list--see-more', function (event) {
        event.preventDefault();
        var holder = $(this).closest(":has(ul.destinations-list)").find("ul.destinations-list");
        holder.find('li.hidden').removeClass('hidden');

        var $link_holder = $(this).closest(".destinations-list--see-more-holder");
        if ($link_holder.length > 0) {
            $link_holder.remove();
        } else {
            $(this).remove();
        }

        holder.removeClass('no-m');
    });

    // BoxWithSubMenu expand subpages list
    $(document).on('click', '.subpages-list--see-more', function (event) {
        event.preventDefault();
        var holder = $(this).closest(":has(ul.subpages-list)").find("ul.subpages-list");
        holder.find('li.hidden').removeClass('hidden');

        var $link_holder = $(this).closest(".subpages-list--see-more-holder");
        if ($link_holder.length > 0) {
            $link_holder.remove();
        } else {
            $(this).remove();
        }

        holder.removeClass('no-m');
    });
});